import {
  groupedPresets,
  moveToUngrouped,
} from 'components/Presets/data/queryKeyFactory';
import { moveToUngroupedGroup } from 'components/Presets/sources/presets';

import { useMutation, useQueryClient } from '@gogame/query';

export const useMoveToUngrouped = (presetKey) => {
  const queryClient = useQueryClient();

  const moveToUngroupedMutation = useMutation(
    moveToUngrouped(presetKey),
    (group) =>
      moveToUngroupedGroup({
        ...group,
      }),
    {
      successMessage: () => 'Preset moved to another group',
      onMutate: async ({ presetIds }) => {
        try {
          queryClient.setQueriesData(
            { queryKey: groupedPresets({}), exact: false },
            (previousPresets) => {
              const myPresets = previousPresets?.my?.reduce(
                (prev, { children, ...group }, index) => {
                  const presets = [];
                  children.forEach((preset) => {
                    if (presetIds.includes(preset.id)) {
                      prev.presetsToMove.push(preset);
                    } else {
                      presets.push(preset);
                    }
                  });
                  prev.my.push({ ...group, children: presets });
                  if (previousPresets.my.length === index + 1) {
                    prev = prev.my.map((gr) => {
                      return gr.id === 0
                        ? {
                            ...gr,
                            children: [...gr.children, ...prev.presetsToMove],
                          }
                        : gr;
                    });
                  }
                  return prev;
                },
                { my: [], presetsToMove: [] }
              );

              return { ...previousPresets, my: myPresets };
            }
          );
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('move to ungrouped', e);
        }
      },
    }
  );

  return [moveToUngroupedMutation.mutateAsync, moveToUngroupedMutation];
};
